import { render } from "./MenuItem.vue?vue&type=template&id=4aa98240&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=4aa98240&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4aa98240"

export default script